var Marionette = require('marionette')
var OptionItemView = require('./ItemOption')

module.exports = Marionette.CollectionView.extend({
  tagName: 'ul',
  childView: OptionItemView,
  options: {
    optionIndex: 0,
    itemIndex: 0
  },
  childViewOptions: function (model) {
    return {
      optionIndex: this.collection.indexOf(model),
      itemIndex: this.getOption('itemIndex')
    }
  },
  childEvents: {
    'item:option:value:changed': function () {
      this.trigger('item:value:changed')
    }
  }
})
